module.exports = __webpack_public_path__ + "static/media/logo-right.6e9fc808.png";